class UniversalHeader extends HTMLElement {
    constructor() {
        super();
        let universalHeaderDebounce = debounce(() => this.universalHeaderResize.bind(this), 500)
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.universalButtonClick.bind(this)));
        window.addEventListener("resize", () => universalHeaderDebounce());
        this.universalDropdown = this.querySelector('.universal-header-container');
    }

    universalButtonClick(event){
        event.preventDefault();
        this.universalDropdown.classList.toggle('open');
    }

    universalHeaderResize() {
        const universalHeaderRemove = this.universalDropdown;
        const universalHeaderBlockRemove = document.querySelectorAll('.universal-block');
        if (window.innerWidth > 768) {
            universalHeaderRemove.classList.remove('open');
            universalHeaderBlockRemove.forEach((element) => {
                element.classList.remove('fade-in', 'fade-in-up', 'fade-in-down');
            });
        }
    }

}

customElements.define('universal-header', UniversalHeader);